import gql from "graphql-tag";

import { Fragment, Mad, Report, ReportReferent } from "../types";
import { MadSupervisorFragment, MAD_SUPERVISOR_FRAGMENT } from "./MadSupervisor";

import { ReportAnswerFragment, REPORT_ANSWER_FRAGMENT } from "./ReportAnswer";
import { REPORT_REFERENT_FRAGMENT } from "./ReportReferent";
import { TaskMinimalFragment, TASK_MINIMAL_FRAGMENT } from "./Task";
import { TemplateFragment, TEMPLATE_FRAGMENT } from "./Template";
import { UserMinimalFragment, USER_MINIMAL_FRAGMENT } from "./User";

export const REPORT_MAD_FRAGMENT = gql`
  fragment ReportMadFragment on Mad {
    id
    referentIds
    taskTrackingEnabled
    skillTrackingEnabled
    templateId
    campaignId
    lastCheckedReport {
      reportAnswers {
        ...ReportAnswerFragment
      }
    }
    talent {
      ...UserMinimalFragment
    }
    referents {
      ...UserMinimalFragment
    }
    madSupervisors {
      ...MadSupervisorFragment
    }
    template {
      ...TemplateFragment
    }
  }

  ${REPORT_ANSWER_FRAGMENT}
  ${USER_MINIMAL_FRAGMENT}
  ${TEMPLATE_FRAGMENT}
  ${MAD_SUPERVISOR_FRAGMENT}
`;

// prettier-ignore
export type ReportMadFragment = Fragment<
  Mad,
  Pick<Mad, "id" | "taskTrackingEnabled" | "skillTrackingEnabled" | "templateId" | "referentIds" | "campaignId">
    & {
        user: UserMinimalFragment;
        lastCheckedReport: { reportAnswers: ReportAnswerFragment[] };
        talent: UserMinimalFragment;
        referents: UserMinimalFragment[];
        madSupervisors: MadSupervisorFragment[];
        templateId: string;
      }
    & { template: TemplateFragment }
>;

export const REPORT_FRAGMENT = gql`
  fragment ReportFragment on Report {
    id
    type
    updatedAt
    filledAt
    checkedAt
    docusignEnvelopeStatus
    document

    canUpdate
    canSign

    tasks {
      ...TaskMinimalFragment
    }

    reportAnswers {
      ...ReportAnswerFragment
    }

    reportReferents {
      ...ReportReferentFragment
    }

    mad {
      ...ReportMadFragment
    }

    template {
      ...TemplateFragment
    }
  }

  ${TASK_MINIMAL_FRAGMENT}
  ${REPORT_ANSWER_FRAGMENT}
  ${REPORT_REFERENT_FRAGMENT}
  ${REPORT_MAD_FRAGMENT}
  ${TEMPLATE_FRAGMENT}
`;

// prettier-ignore
export type ReportFragment = Fragment<
  Report,
  Pick<Report, "updatedAt" | "checkedAt" | "filledAt" | "id" | "type" | "canUpdate" | "document" | "canSign" | "docusignEnvelopeStatus">
    & { tasks: TaskMinimalFragment[] }
    & { reportAnswers: ReportAnswerFragment[] }
    & { reportReferents: ReportReferent[] }
    & { mad: ReportMadFragment }
    & { template: TemplateFragment }
  >;
